import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const InputWrapper = styled.div`
  transition: all 0.2s;
  & * {
    transition: all 0.2s;
  }
  label {
    &.has-error {
      color: ${colors.red};
    }
  }

  input,
  textarea {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid #ccc;
    width: 100%;
    height: 3rem;
    background-color: #f8f9fa;
    border-radius: 0.5rem;
    font-size: 14px;
    padding: 0.5rem 1rem;
    color: ${colors.darkGray};

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 111, 97, 0.4) !important;
      color: ${colors.secondary};
    }
    &::-webkit-input-placeholder {
      color: #b5b5b5;
    }
    &:-moz-placeholder {
      color: #b5b5b5;
    }
    &::-moz-placeholder {
      color: #b5b5b5;
    }
    &:-ms-input-placeholder {
      color: #b5b5b5;
    }
    &::placeholder {
      color: #b5b5b5;
    }

    &.has-error {
      border: none;
      box-shadow: inset 0px 0px 3px 0.05rem red !important;
    }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &[type='number'] {
      -moz-appearance: textfield;
    }
  }
  /* &.range input,
  &.range textarea {
    max-width: calc(50% - 0.5rem);
  } */

  textarea {
    height: 8rem;
    resize: none;
  }
`;

export default InputWrapper;
